import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonos = [{
  id: '01',
  title: 'Kit SOS Primeros 7 Días',
  description: 'Plan de acción para el diagnóstico reciente.',
  price: '$9.000'
}, {
  id: '02',
  title: 'Mapa Visual de Cocina Segura',
  description: 'Carteles y etiquetas imprimibles para toda la familia.',
  price: '$8.000'
}, {
  id: '03',
  title: 'Guía Express del Súper Sin Pánico',
  description: 'Cómo comprar sin TACC sin gastar de más.',
  price: '$8.000'
}, {
  id: '04',
  title: 'Planner Familiar de Freezer',
  description: 'Batch cooking de 2 horas para toda la semana.',
  price: '$9.000'
}, {
  id: '05',
  title: 'Scripts para Colegio, Cumples y Familia',
  description: 'Mensajes listos para copiar y pegar.',
  price: '$8.000'
}, {
  id: '06',
  title: 'Diario de Síntomas y Detective de Contaminación',
  description: 'Registrá patrones y llegá a consulta con claridad.',
  price: '$8.000'
}];
export function Bonos() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-15" data-mp="39bpzx68mtl0u">
      <div className="mx-auto max-w-6xl" data-id="element-16" data-mp="34dequxq5vejo">
        <SectionHeading eyebrow="🎁 Sin cargo extra" title="6 Bonos incluidos" subtitle="Herramientas prácticas que resuelven los momentos más difíciles de la semana." data-id="element-17" data-mp="34ehi56rebj04" />

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="vemdsjtdrat">
          {bonos.map((b, i) => <motion.li key={b.id} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i % 3 * 0.08,
          ease: 'easeOut'
        }} className="relative flex flex-col rounded-2xl border border-forest/10 bg-cream-card p-6 shadow-soft transition-shadow duration-300 hover:shadow-lift" data-id="element-19" data-mp="3s1xzjed4htca" data-mpi={i}>
              <div className="mb-4 flex items-center justify-between" data-id="element-20" data-mp="yrid5ue5u8v9">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-forest/8 font-display text-sm font-semibold text-forest" data-id="element-21" data-mp="12svjs6p2ug38">
                  {b.id}
                </span>
                <GiftIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-22" data-mp="tqumxaxr9w23" />
              </div>
              <h3 className="font-display text-xl leading-tight text-forest-dark" data-id="element-23" data-mp="f0wwspg9mwa9">
                {b.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-forest-dark/65" data-id="element-24" data-mp="62l32ek3ridl">
                {b.description}
              </p>
              <p className="mt-5 flex items-center gap-2 text-sm" data-id="element-25" data-mp="b27ld2esfot9">
                <span className="text-forest-dark/40 line-through" data-id="element-26" data-mp="3s91ba1ls1jh8">
                  {b.price}
                </span>
                <span className="rounded-full bg-forest px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-cream" data-id="element-27" data-mp="126xr49vymj9">
                  Gratis
                </span>
              </p>
            </motion.li>)}
        </ul>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mx-auto mt-10 max-w-2xl rounded-2xl border border-dashed border-clay/40 bg-clay/6 px-6 py-5 text-center font-display text-xl text-forest-dark sm:text-2xl" data-id="element-28" data-mp="39nbx8tg2yptn">
          Valor total de los bonos:{' '}
          <span className="text-forest-dark/40 line-through" data-id="element-29" data-mp="a643kly97fj6">$50.000</span>{' '}
          <span className="font-semibold text-clay" data-id="element-30" data-mp="a7yh3f7745d8">
            → gratis con tu Mega Pack
          </span>
        </motion.p>
      </div>
    </section>;
}